import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-ub04masterconfig',
  templateUrl: './ub04masterconfig.component.html',
  styleUrls: ['./ub04masterconfig.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})

export class Ub04masterconfigComponent implements OnInit {

  ubmasterconfigform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.ubmasterconfigform = this.formBuilder.group({

      soa: ['', Validators.required],
      claimfcode: ['',],
      revenuecode: ['',],
      placeofservice: ['',],
      dischargestatus: ['',],
      occurencecod: ['',],
      admittype: ['',],
      typeofbill: ['',],


    });
  }

  get f() { return this.ubmasterconfigform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.ubmasterconfigform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.ubmasterconfigform.value))
  }
}


